import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {DeleteItemsApi} from "../../../../reduxToolkit/Commons/CommonsApi";
import {TABLES} from "../../../../Apis/Tables";
import {errorMsg} from "../../../../Apis/functions";

/**
 * @fileoverview Hook for managing distribution center application state and actions.
 * @Email azapata@ibl.mx
 * @Author Ferro Zapata Arnulfo
 * @jobTitle Full Stack Developer
 */

/**
 * Custom hook to manage distribution center application logic including
 * search, update, delete, and UI visibility state.
 */

export const DistributionCenterApp =()=>{
    // Redux hook to dispatch actions
    const dispatch = useDispatch();
    const DEV = useSelector(state => state?.CommonsSlice?.development);
    const { permission } = useSelector(state => state.authenticatioauthennSlice);

    const [addShow, setAddShow] = useState(false);
    const [updateData, setUpdateData] = useState('');
    const [isUpdate, setIsUpdate] = useState(false);

    const [deleteDistributionCenter, setDeleteDistributionCenter] = useState(false);
    const [selectDistributionCenterForDelete, setSelectDistributionCenterForDelete] = useState([]);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [searchElement, setSearchElement] = useState('');
    const [bodyForExport, setBodyForExport] = useState();
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [modified,setModified] = useState(false);
    const [results, setResults] = useState(null);
    const option = TABLES.DISTRIBUTION_CENTER;

    const deleteDistributionCenterModal = deleteItem => {
        const tableName = TABLES.DISTRIBUTION_CENTER;
        const body = deleteItem;
        dispatch(DeleteItemsApi({ tableName, body })).then(({payload: {data: { success, code },},}) => {
                if(success){
                    setIsAllChecked(false);
                    setSelectDistributionCenterForDelete([]);
                    setModified(true);
                }else{
                    errorMsg(code);
                }
            }
        );
    };

    return {
        DEV,
        permission,
        selectDistributionCenterForDelete,
        setDeleteDistributionCenter,
        isAllChecked,
        setIsAllChecked,
        setBodyForExport,
        searchElement,
        setSearchElement,
        option,
        search,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        modified,
        setModified,
        results,
        setResults,
        deleteDistributionCenter,
        deleteDistributionCenterModal,
        addShow,
        setAddShow,
        updateData,
        setUpdateData,
        isUpdate,
        setIsUpdate,
        setSelectDistributionCenterForDelete
    };
};
